import React from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useLocationQuery from '../hooks/useLocationQuery';
import LocationForm from '../components/LocationForm';
import getFormTitle from '#/common/utils/getFormTitle';

export interface LocationParams {
  readonly id?: string;
}

const LocationPage: React.FC = () => {
  const { id } = useParams() as LocationParams;
  const locationQuery = useLocationQuery(id);
  const location = locationQuery.data?.getLocation?.data;

  const locationName = location?.name;
  const title = getFormTitle(id, locationName, 'Location');

  return (
    <SubPage title={title} isLoading={locationQuery.loading} showGoBackButton type="form">
      {<LocationForm title={title} location={location || {}} />}
    </SubPage>
  );
};

export default React.memo(LocationPage);
